import { render } from "./Management.vue?vue&type=template&id=b8f63732&scoped=true&ts=true&lang=pug"
import script from "./Management.vue?vue&type=script&lang=ts"
export * from "./Management.vue?vue&type=script&lang=ts"

import "./Management.vue?vue&type=style&index=0&id=b8f63732&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f63732"]])

export default __exports__